var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "asta-drawer",
      attrs: { app: "", fixed: "", temporary: "" },
      scopedSlots: _vm._u([
        {
          key: "append",
          fn: function () {
            return [
              _c(
                "v-card",
                { staticClass: "ma-4" },
                [
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-item",
                        { attrs: { link: "" }, on: { click: _vm.gotoHome } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "text" } }, [
                                _vm._v("chevron_left"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "font-weight-bold" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Account & Aste")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-list-item-subtitle", [
                                _vm._v(
                                  _vm._s(_vm.user_displayName) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.drawer,
        callback: function ($$v) {
          _vm.drawer = $$v
        },
        expression: "drawer",
      },
    },
    [
      _c(
        "div",
        { staticClass: "drawer-header navy" },
        [
          _c(
            "v-avatar",
            { staticClass: "drawer-user-avatar", attrs: { size: "34" } },
            [
              _vm.user_pic
                ? _c("v-img", { attrs: { contain: "", src: _vm.user_pic } })
                : _c("v-icon", { attrs: { color: "white" } }, [
                    _vm._v("account_circle"),
                  ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "drawer-user-info" }, [
            _c("div", { staticClass: "drawer-user-name white--text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.user_displayName || _vm.user_uid) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "drawer-league-row secondary--text" },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "drawer-league-icon secondary--text",
                    attrs: { "x-small": "" },
                  },
                  [_vm._v("\n          security\n        ")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "drawer-league-name" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.asta_info.name) + "\n        "
                  ),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "white--text",
              attrs: { rounded: "", icon: "" },
              on: { click: _vm.toggle },
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      !_vm.admin && !_vm.my_squadra
        ? _c(
            "div",
            {
              staticClass: "error white--text pa-2 ma-2",
              staticStyle: { "border-radius": "3px" },
            },
            [
              _vm._v(
                "\n    Solo i presidenti delle squadre possono partecipare all'asta. I co-gestori\n    e gli ospiti non possono parteciparvi ma possono seguirne l'andamento.\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-list",
        { attrs: { dense: "" } },
        [
          _vm.my_squadra
            ? _c(
                "v-list-item",
                { attrs: { link: "" }, on: { click: _vm.promptEditSquadra } },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _vm.mySquadraPic
                        ? _c("v-img", {
                            staticClass: "drawer-team-icon",
                            attrs: { contain: "", src: _vm.mySquadraPic },
                          })
                        : _c("v-icon", { attrs: { color: "text" } }, [
                            _vm._v("admin_panel_settings"),
                          ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold" },
                        [
                          _c("div", { staticClass: "font-weight-bold" }, [
                            _vm._v("La mia squadra"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-list-item-subtitle", [
                        _vm._v(" " + _vm._s(_vm.mySquadraName) + " "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.premium
            ? _c(
                "v-list-item",
                { attrs: { link: "" }, on: { click: _vm.promptSblocco } },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "orange" } }, [
                        _vm._v("workspace_premium"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "orange--text font-weight-bold" },
                        [_vm._v("Sblocca")]
                      ),
                      _vm._v(" "),
                      _c("v-list-item-subtitle", [
                        _vm.asta_info.counter
                          ? _c("div", [
                              _vm._v("\n            Hai ancora "),
                              _c("b", [_vm._v(_vm._s(_vm.asta_info.counter))]),
                              _vm._v(" assegnazioni.\n          "),
                            ])
                          : _c("div", [_vm._v("Sblocca per continuare.")]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.admin || _vm.my_squadra
            ? _c(
                "v-list-item",
                { attrs: { link: "" }, on: { click: _vm.promptChangeAdmin } },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("engineering"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold" },
                        [_vm._v("Amministratore Asta\n        ")]
                      ),
                      _vm._v(" "),
                      _c("v-list-item-subtitle", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.adminUsername) +
                            "\n          "
                        ),
                        _c("div", {
                          staticClass: "stato",
                          class: _vm.adminPresenceClass,
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: {
                            "error--text":
                              _vm.adminPresence !=
                              _vm.Constants.PRESENCE_STATES.ONLINE,
                          },
                        },
                        [
                          _vm._v(
                            "\n          L'amministratore deve rimanere sempre online durante il corso\n          dell'asta o Asta Live si bloccherà.\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.admin || _vm.my_squadra
            ? _c(
                "v-list-item",
                { attrs: { link: "" }, on: { click: _vm.promptDownloadRose } },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("download"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold" },
                        [_vm._v("Download Rose")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.admin || _vm.my_squadra
            ? _c(
                "v-list-item",
                { attrs: { link: "" }, on: { click: _vm.openDialogInvito } },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("person_add"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold" },
                        [_vm._v("Invita")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-list-item",
            { attrs: { link: "" } },
            [
              _c(
                "v-list-item-icon",
                [
                  _c("v-icon", { attrs: { color: "text" } }, [
                    _vm._v("support "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", { staticClass: "font-weight-bold" }, [
                    _c(
                      "a",
                      {
                        staticClass: "blue-grey--text text-decoration-none",
                        attrs: {
                          href: "https://www.facebook.com/groups/500245610367729/",
                          target: "_blank",
                        },
                      },
                      [_vm._v("Supporto")]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            { attrs: { link: "" }, on: { click: _vm.promptComeFunziona } },
            [
              _c(
                "v-list-item-icon",
                [
                  _c("v-icon", { attrs: { color: "secondary" } }, [
                    _vm._v("not_listed_location"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item-content",
                [
                  _c(
                    "v-list-item-title",
                    { staticClass: "secondary--text font-weight-bold" },
                    [_vm._v("Come funziona?")]
                  ),
                  _vm._v(" "),
                  _c("v-list-item-subtitle", [
                    _vm._v("Guida veloce a Asta Live"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            {
              staticClass: "drawer-news-icon",
              attrs: { link: "" },
              on: { click: _vm.promptChangeLog },
            },
            [
              _c(
                "v-list-item-icon",
                [
                  _c("v-icon", { attrs: { color: "text" } }, [
                    _vm._v("new_releases"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", { staticClass: "font-weight-bold" }, [
                    _vm._v("\n          Novità Asta Live\n        "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pb-2 text-center" }, [
        _c("small", [_vm._v("v. " + _vm._s(_vm.version))]),
      ]),
      _vm._v(" "),
      _vm._v(" "),
      _c("dialog-invito"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }